import { Injectable, Injector } from '@angular/core';
import { Effect, Actions } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';

import { Store } from '@ngrx/store';
import { AppState } from '../app.state';

import { SetLocale } from '../main/locale/locale.actions';
import { ActionTypes, SetKioskFetchingState, AddKioskAppointment, SetKioskSubscriptionId, SetKioskError, StartKioskTimer, StopKioskTimer, AddKioskPatient } from './kiosk.actions';
import { KioskService, IAppointmentsByHinParams } from './kiosk.service';
import { State as KioskState, KioskError, getPatients } from './kiosk.reducer';
import { KioskAppointment, KioskPatient } from './kiosk.model';

import { Locale } from '../shared/models/locale.model';
import { getLocale } from '../main/locale/locale.reducer';

@Injectable()
export class KioskEffects {
  @Effect() fetchKiosk$ = this.actions$
    .ofType(ActionTypes.FETCH_KIOSK)
    .switchMap((data): Observable<KioskState> => this.injector.get(KioskService).getAppointmentsByHin(data.payload))
    .withLatestFrom(
      this.store.select(getLocale),
      (data: KioskState, appLocale: Locale) => ({ data, appLocale })
    )
    .mergeMap(({ data, appLocale }): Observable<any> => {
      let error: KioskError = null;
      const { appointments, subscriptionId, locale } = data;

      if (!appointments.length) {
        error = KioskError.NoAppointments;
      }

      if (!!appointments.find((appointment: KioskAppointment) => appointment.hinExpired === true || appointment.hinExpired === null)) {
        error = KioskError.Hin;
      }

      if (appLocale !== locale) {
        this.injector.get('LanguageService').switchLanguage();
      }

      const actions = [
        new AddKioskAppointment(appointments),
        new AddKioskPatient(appointments),
        new SetKioskSubscriptionId(subscriptionId),
        new SetLocale(locale),
        new SetKioskFetchingState(false),
      ];

      if (error !== null) {
        actions.push(new SetKioskError(error));
      }

      return Observable.from(actions);
    });

  @Effect() startTimer$ = this.actions$
    .ofType(ActionTypes.START_KIOSK_TIMER)
    .switchMap(() => {
      return Observable.timer(60000).switchMap(() => Observable.of(new StopKioskTimer()));
    });

  @Effect() addKioskPatients$ = this.actions$
    .ofType(ActionTypes.ADD_KIOSK_PATIENT)
    .switchMap((): Observable<KioskPatient[]> => this.store.select(getPatients))
    .mergeMap((patients: KioskPatient[]): Observable<any> => {
      const patientWithInvalidInfo: KioskPatient[] = patients.filter((patient: KioskPatient) => {
        const { profile } = patient
        return !profile.contactMethods.length || !profile.street || !profile.postalCode;
      });

      if (patientWithInvalidInfo.length) {
        return Observable.from([
          new SetKioskError(KioskError.InvalidInformations),
        ]);
      }

      return Observable.from([]);
    });

  constructor(
    private injector: Injector,
    private actions$: Actions,
    private store: Store<AppState>,
  ) {}
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/kiosk/kiosk.effects.ts